/*
 * Which build is live (2026-10-29): the SPA's own commit (baked in at image
 * build) beside the API's (from /healthz). After a Manual Deploy both should
 * show the new commit; a mismatch means half the deploy has not landed.
 * "dev" outside a CI-built image.
 */

import { useEffect, useState } from "react";
import { Text } from "@mantine/core";
import { API_BASE } from "../api/config";

/** First 7 characters of a commit, or "dev". */
export function shortBuild(v: string | null | undefined): string {
  const s = (v ?? "").trim();
  return s ? s.slice(0, 7) : "dev";
}

export function BuildStamp() {
  const app = shortBuild(import.meta.env.VITE_APP_VERSION);
  const [api, setApi] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    fetch(`${API_BASE}/healthz`)
      .then((r) => r.json())
      .then((body: { version?: string }) => {
        if (live) setApi(shortBuild(body.version));
      })
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, []);

  const mismatch = api !== null && api !== app;
  return (
    <Text
      fz="xs"
      c={mismatch ? "orange" : "dimmed"}
      mt="auto"
      pt="sm"
      title={mismatch ? "The app and the API are on different builds: the deploy has not fully landed." : undefined}
      data-testid="build-stamp"
    >
      Build {app}
      {api !== null && api !== app ? ` · API ${api}` : ""}
    </Text>
  );
}
